import React, { useEffect, useState } from "react";
import "./OxfordMUNLanding.css";
import OxfordMUNSection from "./AboutOxfordMun";
import SecretarySection from "./SecretarySection";
import EventsSection from "./SliderEvent";
import CommitteesSection from "./Committees";
import AboutFlame from "./AboutFlame";
import FaqSection from "./FAQ";
import HeroSection from "./HeroSection";
import Testimonial from "./Testimonial";
import SubmittionForm from "./SubmitForm";
import CounsellorModal from "./CounsellorDetailsModel";

const highlights = [
  {
    title: "DELEGATE FEE",
    content:
      "₹ 30,000/- for Indian Students\n$ 500/- for International Students",
  },
  {
    title: "DATES",
    content: "4TH – 6TH AUGUST, 2025",
  },
  {
    title: "PARTICIPANTS",
    content: "GRADES 9 – 12",
  },
  {
    title: "VENUE",
    content: "FLAME UNIVERSITY, PUNE",
  },
];

const eventData = [
  {
    title: "Kila Quest",
    image: "/assets/images/pillarimage/kila_quest.jpg",
    description: "Embark on a thrilling scavenger hunt...",
  },
  {
    title: "The Superhero Project",
    image: "/assets/images/pillarimage/superhero.jpg",
    description: "Unleash your creativity with the Superhero Project...",
  },
  {
    title: "Trek to Triumph",
    image: "/assets/images/pillarimage/trek_to_triumph.jpg",
    description: "Navigate challenging terrains...",
  },
  // Add remaining events as needed
];

const OxfordMUNLanding = () => {
  const [showModal, setShowModal] = useState(false);
  const [showCounsellorModal, setShowCounsellorModal] = useState(false);
  const [source, setSource] = useState("");

  const handleToggle = (eventSource = "") => {
    setSource(eventSource);
    setShowModal((prev) => !prev);
  };

  const handleCounsollerToggle = () => {
    setShowCounsellorModal((prev) => !prev);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Run on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="oxfordmun-landing">
      <div className="header-container spacing-right-left">
        <div className="logo-item">
          <img
            src="/assets/images/OxfordMunNew/OxfordMun2025.svg"
            alt="OxfordMUN India 2025"
            className="logo-icon"
          />
        </div>
        <div className="right-side-logo">
          <div className="logo-item">
            <img
              src="/assets/images/OxfordMunNew/mu20_main_logo_new.svg"
              alt="MU20 School of Opportunity logo"
              className="logo-icon"
            />
          </div>

          <div
            className="logo-item"
            style={{
              position: "relative",
              top: "-4px",
            }}
          >
            <img
              src="/assets/images/OxfordMunNew/flame_university.svg"
              alt="Flame University logo"
              className="logo-icon"
            />
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <HeroSection
        handleToggle={() => {
          handleToggle("hero_section");
        }}
        handleCounsollerToggle={handleCounsollerToggle}
        isMobile={isMobile}
      />

      {/* Event Highlights */}
      <div className="highlights-container spacing-right-left">
        {highlights.map((item, idx) => (
          <div className="highlight-card" key={idx}>
            <div className="highlight-header">
              <span className="highlight-title">{item.title}</span>
              <img
                src="/assets/images/OxfordMunNew/event_icon1.svg"
                alt="icon"
                className="highlight-icon"
              />
            </div>
            <p className="highlight-content">
              {item.content.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
      </div>
      {/* OxfordMUNSection */}

      <OxfordMUNSection
        handleToggle={() => {
          handleToggle("about_oxfordmun_2025");
        }}
        handleCounsollerToggle={handleCounsollerToggle}
      />

      {/* Home conference section */}

      <div className="conference-section">
        <div className="hero-content">
          <h2>WIN A 100% SCHOLARSHIP</h2>
          <p>TO ATTEND THE</p>
          <h1>OxfordMUN Home Conference</h1>
        </div>
        <img src="/assets/images/OxfordMunNew/Oxford_collage.svg" />
      </div>

      {/* Secretary Section */}
      <SecretarySection
        handleToggle={() => {
          handleToggle("secretary_general_model");
        }}
        handleCounsollerToggle={handleCounsollerToggle}
        isMobile={isMobile}
      />

      {/* Unique oxfordMun */}
      <EventsSection
        isMobile={isMobile}
        handleToggle={() => {
          handleToggle("unique_oxfordmun_2025");
        }}
      />

      {/* committies section */}
      <CommitteesSection
        isMobile={isMobile}
        handleModal={() => {
          handleToggle("committees_and_agenda");
        }}
      />

      {/* Testimonial section */}
      <Testimonial isMobile={isMobile} />

      {/* About flame */}
      <AboutFlame
        toggleModal={() => {
          handleToggle("about_flame_university");
        }}
      />

      {/* FAQ Section */}
      <FaqSection />

      {
        <SubmittionForm
          isOpen={showModal}
          onClose={handleToggle}
          eventSource={source}
        />
      }
      {showCounsellorModal && (
        <CounsellorModal
          isOpen={showCounsellorModal}
          onClose={handleCounsollerToggle}
        />
      )}
    </div>
  );
};

export default OxfordMUNLanding;
